import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import { Tab, TabList, TabPanel, Tabs as RTabs } from 'react-tabs';

const Tabs = ({
  tabs,
  type,
  getTabTitle,
  className,
  disabled,
  tabKey,
  ...props
}) => (
  <RTabs
    className={classNames(
      'tabs',
      {
        [`tabs--${type}`]: type // line
      },
      className
    )}
    selectedTabClassName="active"
    {...props}
  >
    <TabList>
      {tabs.map(tab => (
        <Tab disabled={disabled} key={`${tab[tabKey]}-title`}>
          {getTabTitle(tab)}
        </Tab>
      ))}
    </TabList>

    {tabs.map(tab => (
      <TabPanel key={`${tab[tabKey]}-body`}>
        {isFunction(tab.body) ? tab.body() : tab.body}
      </TabPanel>
    ))}
  </RTabs>
);

Tabs.defaultProps = {
  getTabTitle: tab => tab.title,
  tabKey: 'title'
};

Tabs.propTypes = {
  type: PropTypes.oneOf(['line', 'settings']),
  className: PropTypes.string,
  getTabTitle: PropTypes.func,
  disabled: PropTypes.bool,
  tabKey: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node.isRequired,
      body: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
    })
  )
};

export default Tabs;
